import React, { useEffect } from 'react'
import { Field, useFormikContext } from 'formik'
import cn from 'classnames'
import isEmpty from 'lodash/isEmpty'
import { css, StyleSheet } from 'aphrodite'
import ValidationErrorMessage from './ValidationErrorMessage'

export default function Select({
    name,
    className,
    label,
    validate,
    options = [],
    optionValue = 'id',
    optionLabel = 'name',
    loading = false,
    empty = false,
    optional = false,
    help,
    ...attributes
}) {
    const { setFieldValue, values, errors, touched } = useFormikContext()
    const value = values[name]
    const error = errors[name]
    const touch = touched[name]

    useEffect(() => {
        const strValue = typeof value === 'number' ? String(value) : value
        if (!empty && isEmpty(strValue) && !isEmpty(options)) {
            setFieldValue(name, options[0][optionValue])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options])

    return (
        <div className={css(styles.fieldContainer)}>
            {label && (
                <label htmlFor={name} className="label">
                    {label} &nbsp;
                    {optional && <span className={css(styles.optional)}>shart emas</span>}
                </label>
            )}

            <div className={cn('select', css(styles.selectWrapper), className, { 'is-loading': loading })}>
                <Field name={name} id={name} component="select" validate={validate} className={css(styles.select)} {...attributes}>
                    {empty && <option value="" />}

                    {options.map((item) => (
                        <option value={item[optionValue]} key={item[optionValue]}>
                            {typeof optionLabel === 'function' ? optionLabel(item) : item[optionLabel]}
                        </option>
                    ))}
                </Field>
            </div>

            <ValidationErrorMessage name={name} />

            {help && (!error || !touch) && <p className={css(styles.helpText)}>{help}</p>}
        </div>
    )
}

const styles = StyleSheet.create({
    fieldContainer: {
        display: 'flex',
        flexDirection: 'column',
        // gap: '0.5rem',
        marginBottom: '1rem',
    },
    label: {
        fontSize: '1rem',
        fontWeight: '600',
        color: '#333',
    },
    optional: {
        fontSize: '0.85rem',
        color: '#888',
    },
    selectWrapper: {
        width: '100%',
        position: 'relative',
    },
    select: {
        width: '100%',
        padding: '0.6rem 1rem',
        fontSize: '1rem',
        borderRadius: '6px',
        border: '1px solid #ccc',
        transition: 'border-color 0.3s ease',
        ':focus': {
            borderColor: '#007BFF',
            outline: 'none',
        },
    },
    helpText: {
        fontSize: '0.85rem',
        color: '#666',
    },
})
